module.exports = __webpack_public_path__ + "img/preco_senior.99c4ce2d.png";